/**
 * One surface for every menu, popover and picker (ChatGPT's): a white panel
 * in light and the card tone in dark, 16px radius, no border, and the
 * `--popover-shadow` elevation (a hairline plus a soft wide drop).
 */
export const MENU_SURFACE_CLASS =
  'bg-popover text-popover-foreground rounded-2xl border-0 shadow-popover';

/** Menu panels inset their rows 6px, so 10px rows sit concentric in 16px. */
export const MENU_PANEL_PADDING_CLASS = 'p-1.5';

/**
 * A menu row: 36px tall with 14/20 text, a 10px-radius highlight in the
 * shared hover wash (darkens in light, lightens in dark, on any surface).
 */
export const MENU_ITEM_CLASS =
  'type-body min-h-9 rounded-[10px] py-2 focus:bg-hover-wash focus:text-accent-foreground';

/** Horizontal inset of a plain row (rows with an indicator set their own). */
export const MENU_ITEM_INSET_CLASS = 'px-2.5';
